import React from 'react'
import { connect } from 'react-redux'
import Loader from 'components/D3Loader'
import { caregiverActions } from 'store/selectedParticipant'
import SelectPTPPage from '../components/SelectPTPPage'

const mapStateToProps = state => {
    const { caregiver, loading, strings, user } = state
    return {
        loading: loading.general,
        isCaregiver: !!user?.is_caregiver,
        participants: caregiver?.participants || [],
        selected: caregiver?.selected || null,
        strings
    }
}

const mapDispatchToProps = {
    fetchParticipants: caregiverActions.fetchParticipants,
    setSelected: caregiverActions.setSelected
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(props => {
    if (props.loading) return <Loader />
    return <SelectPTPPage {...props} />
})


